import React from 'react'
import { Route, Routes } from 'react-router-dom'
import EmailPage from '../../pages/features/email/EmailPage'

export default function EmailNav() {
    return (
        <Routes>
            <Route path="/" element={<EmailPage />} />

        </Routes>
    )
}
